import dayjs from "dayjs";
import { normalizeFilePath } from "./url";

function getValueByPath(obj, pathArray) {
    if (!obj) return null;
    return pathArray.reduce((current, key) => {
        if (current == null) return null;
        return current.hasOwnProperty(key) ? current[key] : null;
    }, obj);
}

export function buildSteps(formValues, steps = [], parentPath = []) {
    return (steps || []).map((step) => {
        const { sourceDoc, sourceType } = step;
        const field = sourceDoc || {};
        const fieldId = field._id;

        // full path to this field inside the form values (array)
        const fieldPath = [...parentPath, fieldId];

        const currentRoot = parentPath.length ? getValueByPath(formValues, parentPath) || {} : formValues || {};

        let value = getValueByPath(currentRoot, [fieldId]);
        let expiredAtValue = getValueByPath(formValues, ["expiredAt", ...fieldPath]);

        if (
            (sourceType && sourceType.toString().toLowerCase() === "document_setting") ||
            Array.isArray(step.steps) && step.steps.length > 0 ||
            Array.isArray(field.steps) && field.steps.length > 0
        ) {
            const nestedSourceSteps = step.steps || field.steps || [];

            const nestedSteps = buildSteps(formValues, nestedSourceSteps, fieldPath);

            return {
                sourceId: fieldId,
                sourceType,
                value: {
                    steps: nestedSteps,
                },
            };
        }

        // Normalize file values
        if (field?.type === "file") {
            if (typeof value === "string") {
                value = normalizeFilePath(value);
            } else if (value && typeof value === "object") {
                value = normalizeFilePath(value?.file?.response || value?.url || value);
            }
        }

        if (field?.type === "phone_number") {
            if (value && typeof value === "object") {
                const { countryCode, phoneNumber } = value
                value = `${countryCode || ""}${phoneNumber || ""}`
            }
        }

        // Date/time conversions
        if (value && dayjs.isDayjs(value)) {
            switch (field?.type) {
                case "date":
                    value = value.format("YYYY-MM-DD");
                    break;
                case "datetime":
                    value = value.format("YYYY-MM-DD HH:mm:ss");
                    break;
                case "time":
                    value = value.format("HH:mm:ss");
                    break;
                default:
                    value = value.toISOString();
            }
        }

        // Convert expiredAt dayjs
        if (expiredAtValue && dayjs.isDayjs(expiredAtValue)) {
            expiredAtValue = expiredAtValue.toISOString();
        }


        // if (value && typeof value === "object" && !Array.isArray(value) && field?.type === "multi_select") {
        //     // convert numeric-key obj to array in order
        //     const arr = Object.keys(value)
        //         .map((k) => ({ k, n: parseInt(k, 10) }))
        //         .filter(({ n }) => !Number.isNaN(n))
        //         .sort((a, b) => a.n - b.n)
        //         .map(({ k }) => value[k]);
        //     value = arr;
        // }

        return {
            sourceId: fieldId,
            sourceType,
            value:
                value === undefined || value === "" || value === null ||
                (Array.isArray(value) && value.length === 0)
                    ? null
                    : value,
            ...(expiredAtValue ? { expiredAt: expiredAtValue } : {}),
        };
    });
}

export const cleanStep = (step) => {
    const {invalid, ...rest} = step
    if (rest.value && typeof rest.value === 'object' && Array.isArray(rest.value.steps)) {
        return {
            ...rest,
            value: {
                ...rest.value,
                steps: rest.value.steps.map(cleanStep)
            }
        }
    }
    return rest
}

// A step is "filled" when it carries a real value.
// Nested documents (value: { steps: [...] }) are filled when any nested step is filled.
export const isStepFilled = (step) => {
    const value = step?.value;
    if (value === null || value === undefined || value === "") return false;
    if (typeof value === "object" && Array.isArray(value.steps)) return value.steps.some(isStepFilled);
    if (Array.isArray(value)) return value.length > 0;
    return true;
};

// A document is empty when none of its steps are filled.
export const isDocumentFilled = (doc) => (doc?.steps || []).some(isStepFilled);

// Collapse an empty nested group (value: { steps: [...all empty] }) to value: null
// so the backend skips validation on it; recurse to prune partially-filled groups.
export const pruneEmptyNested = (step) => {
    const value = step?.value;
    if (value && typeof value === "object" && Array.isArray(value.steps)) {
        if (!value.steps.some(isStepFilled)) return { ...step, value: null };
        return { ...step, value: { ...value, steps: value.steps.map(pruneEmptyNested) } };
    }
    return step;
};
